// extracted by css-extract-rspack-plugin
export default {"user-link":"WoO1qU","userLink":"WoO1qU","link-banned":"AImEQ6","linkBanned":"AImEQ6"};